import FirmwareRolloutDTO from './FirmwareRolloutDTO';
import RolloutSampleStatusDTO from './RolloutSampleStatusDTO';

export default class FirmwareRolloutDetailDTO {

    public rollout: FirmwareRolloutDTO;
    public samples: RolloutSampleStatusDTO[] = [];

    constructor(data: { [key: string]: any }) {
        this.rollout = new FirmwareRolloutDTO(data['rollout'] ?? {});
        this.samples = Array.isArray(data['samples']) ? data['samples']
            .map((sample: any) => new RolloutSampleStatusDTO(sample)) : [];
    }
}
